module.exports = __webpack_public_path__ + "img/BFSG.0599c3a6.png";